var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_103_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1881 0.467636L0.492615 4.8534C0.0847043 4.99665 0.109553 5.58172 0.52814 5.68986L6.42535 7.16578L7.32963 13.1793C7.39106 13.6148 7.98455 13.6976 8.16286 13.2955L13.7533 1.05541C13.937 0.594361 13.5433 0.366989 13.1881 0.467636ZM12.5325 1.62059L7.97554 11.5935L7.24889 6.74916C7.22352 6.57362 7.09469 6.43077 6.9227 6.38745L2.17199 5.19897L12.5325 1.62059Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_103_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowWhite);
export default __webpack_public_path__ + "static/media/arrow_white.4a9443cdefa7145f3ea84c9a7b679667.svg";
export { ForwardRef as ReactComponent };